import type { Config } from 'tailwindcss';
import plugin from 'tailwindcss/plugin';
import {
  borderRadius,
  responsiveBorderRadius,
} from './src/tailwind/border-radius';
import colorConfig from './src/tailwind/colors';
import container from './src/tailwind/container';
import { iconSizes, sizingConfig } from './src/tailwind/sizing';
import { spacingConfig } from './src/tailwind/spacing';
import typography from './src/tailwind/typography';

const borderWidth = {
  none: '0',
  DEFAULT: '1px',
  1: '1px',
  2: '2px',
  3: '3px',
  4: '4px',
  5: '5px',
  6: '6px',
};

const config = {
  content: [
    './src/pages/**/*.{js,ts,jsx,tsx,mdx}',
    './src/components/**/*.{js,ts,jsx,tsx,mdx}',
    './src/app/**/*.{js,ts,jsx,tsx,mdx}',
    './src/features/**/*.{js,ts,jsx,tsx,mdx}',
  ],
  theme: {
    extend: {
      scale: {
        '80': '0.8',
      },
      transitionDuration: {
        '250': '250ms',
        '400': '400ms',
      },
      zIndex: {
        '100': '100',
        '500': '500',
        '1000': '1000',
        top: '9999',
      },
      aspectRatio: {
        '3/2': '3/2',
      },
    },
    screens: {
      xxs: '0px',
      xs: '360px',
      s: '600px',
      m: '900px',
      l: '1200px',
      xl: '1404px',
      xxl: '1704px',
    },
    fontSize: iconSizes,
    ...spacingConfig,
    ...sizingConfig,
    borderRadius,
    outlineWidth: borderWidth,
    borderWidth,
    ...colorConfig,
    boxShadow: {
      'option-inner': '0 0 0 1px #FFF, 0 0 0 3px #2E2B29',
      default: '0 0 0 3px theme(borderColor.hover.DEFAULT)',
    },
    backgroundImage: {
      'partners-hero-pattern': "url('/images/partners-hero-bg.webp')",
    },
  },
  corePlugins: {
    container: false,
  },
  plugins: [
    container,
    typography,
    responsiveBorderRadius,
    plugin(function ({ addVariant }) {
      //We need those variants, to add fallback because gap in flexbox is not supported in all browsers(95.24% supports in 16.01.2025)
      addVariant('modern', '@supports selector(div:has(> .flex))');
      addVariant('no-flex-gap', '@supports not selector(div:has(> .flex))');
    }),
  ],
} satisfies Config;

export default config;
